<hsuc-safe-script [scriptCode]="safeHtml"></hsuc-safe-script>
